import React from 'react';
import i18n, { setupI18n } from '../../../i18n';

export function LanguageSelect() {
  const langs = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'pt', label: 'Português' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'it', label: 'Italiano' },
    { code: 'zh', label: '简体中文' },
    { code: 'ja', label: '日本語' },
    { code: 'ko', label: '한국어' },
    { code: 'ar', label: 'العربية' },
    { code: 'hi', label: 'हिन्दी' },
    { code: 'ru', label: 'Русский' },
  ];

  const current = i18n.language || 'en';

  return (
    <label className="flex items-center gap-2 text-xs text-gray-400">
      <span className="sr-only">Language</span>
      <select
        aria-label="Language selector"
        className="bg-transparent border border-gray-600 rounded px-2 py-1 text-xs hover:border-primary focus:outline-none"
        value={current}
        onChange={(e)=>{ const lng=e.target.value; setupI18n(lng); i18n.changeLanguage(lng); try{ localStorage.setItem('i18n.lang', lng);}catch(_){}}}
      >
        {langs.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
    </label>
  );
}
